import { config } from '../utils/config';

class MOMAuthService {
  constructor() {
    this.clientId = config.momAzureClientId;
    this.tenantId = config.momAzureTenantId;

    // Use frontend callback (must match redirect URI registered in Azure app)
    this.redirectUri = 'http://localhost:3000/mom-auth-callback';
  }

  getMOMAuthUrl() {
    const params = new URLSearchParams({
      client_id: this.clientId,
      response_type: 'code',
      redirect_uri: this.redirectUri,
      response_mode: 'query',
      scope: 'openid profile offline_access',
      state: 'mom-auth',
      prompt: 'select_account'
    });

    return `https://login.microsoftonline.com/${this.tenantId}/oauth2/v2.0/authorize?${params}`;
  }

  getMOMAccessToken() {
    return sessionStorage.getItem('mom_access_token');
  }

  isAuthenticated() {
    return !!this.getMOMAccessToken();
  }

  logout() {
    sessionStorage.removeItem('mom_access_token');
  }
}

export default MOMAuthService;
